export default {
    methods: {
        setBlogId() {
            if (document.body.classList.contains('blog-3')) {
                return 3;
            } else if (document.body.classList.contains('blog-2')) {
                return 2;
            } else {
                return 1;
            }
        }
    }
};
